// The quotation_details.status enum. Mirrors backend/models/quotationDetails.js.
export const QUOTATION_STATUSES = ["Draft", "Sent", "Accepted", "Rejected", "Expired", "Cancelled"];

const STYLES = {
  Draft:     { badge: "bg-gray-100 text-gray-600",     dot: "bg-gray-400",   text: "text-gray-500",   rail: "border-l-gray-300" },
  Sent:      { badge: "bg-brand-100 text-brand-700",   dot: "bg-brand-500",  text: "text-brand-700",  rail: "border-l-brand-400" },
  Accepted:  { badge: "bg-green-100 text-green-700",   dot: "bg-green-500",  text: "text-green-700",  rail: "border-l-green-400" },
  Rejected:  { badge: "bg-rose-100 text-rose-700",     dot: "bg-rose-500",   text: "text-rose-700",   rail: "border-l-rose-400" },
  Expired:   { badge: "bg-orange-100 text-orange-700", dot: "bg-orange-500", text: "text-orange-700", rail: "border-l-orange-400" },
  Cancelled: { badge: "bg-gray-200 text-gray-500",     dot: "bg-gray-300",   text: "text-gray-400",   rail: "border-l-gray-300" },
};

const FALLBACK = {
  badge: "bg-gray-100 text-gray-700",
  dot: "bg-gray-400",
  text: "text-gray-500",
  rail: "border-l-gray-200",
};

export const quotationStatusStyle = (status) => STYLES[status] || FALLBACK;
